// Material Kit 2 PRO React components
import MKTypography from "components/MKTypography";

// Images
import logoCT from "assets/images/footer-logo.png";

const date = new Date().getFullYear();

export default {
  brand: {
    image: logoCT,
    route: "/",
  },
  menus: [
    {
      name: "Services",
      items: [
        { name: "Find a House", href: "/services/house" },
        { name: "Find a Car", href: "/services/car" },
        { name: "Find a Land", href: "/services/land" },
      ],
    },
    {
      name: "Other Services",
      items: [
        { name: "Find a Maid", href: "/services/maid" },
        { name: "Find a Nanny", href: "/services/nanny" },
        { name: "Find a Driver", href: "/services/drivers" },
      ],
    },
    {
      name: "resources",
      items: [
        { name: "Booking", href: "/services/booking" },
        { name: "Contact us", href: "/contact" },
        { name: "Career", href: "/employee" },
      ],
    },
    {
      name: "legal",
      items: [
        { name: "Terms & Conditions", href: "/terms-condtions" },
        { name: "Privacy Policy", href: "/privacy-policy" },
        { name: "Disclaimer", href: "/disclaimer" },
      ],
    },
  ],
 copyright: (
  <MKTypography
    variant="button"
    fontWeight="regular"
    sx={{
      color: "#94a3b8",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: 0.5,
      flexWrap: "wrap",
      textAlign: "center",
      py: 2,
    }}
  >
    © {date} Helper Everywhere. All rights reserved.
    <span>Designed by</span>
    <a
      href="https://www.linkedin.com/in/tom-amundala/"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: "#94a3b8",
        textDecoration: "none",
        fontWeight: 500,
        transition: "opacity 0.2s ease",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.opacity = 0.7)}
      onMouseLeave={(e) => (e.currentTarget.style.opacity = 1)}
    >
      Amundala
    </a>
  </MKTypography>
),
};
